import React from "react";
import CreateFineSetting from "./modules/CreateFineSetting";
import { 
  useGetFineCategoriesQuery, 
  useGetFineByIdQuery,
  useUpdateFineMutation 
} from "../../../store/admin/settings/fineSlice";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Loader from "../../../components/Ui/Loader";

const EditFine = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: categories, isLoading: isLoadingCategories } = useGetFineCategoriesQuery();
  const { data: fineData, isLoading: isLoadingFine } = useGetFineByIdQuery(id);
  const [updateFine, { isLoading: isUpdating }] = useUpdateFineMutation();

  const handleUpdate = async (values) => {
    try {
      const result = await updateFine({ id, ...values }).unwrap();
      if (result.status) {
        toast.success(result.message || "Fine updated successfully");
        navigate("/super_admin/settings/fine_settings");
      } else {
        toast.error(result.message || "Failed to update fine");
      }
    } catch (error) {
      toast.error(error?.data?.message || "An error occurred");
    }
  };

  if (isLoadingFine || isLoadingCategories) {
    return <Loader />;
  }

  return (
    <section className="px-2 px-lg-4 min-vh-100 rounded-4">
      <CreateFineSetting 
        categories={categories} 
        isLoading={isLoadingCategories}
        initialData={fineData}
        onSubmit={handleUpdate}
        isUpdating={isUpdating}
      />
    </section>
  );
};

export default EditFine;

